/**
 * A marca do Chama Um.
 *
 * O símbolo é uma casa cujo vão interno é um balão de fala com rabicho para a
 * esquerda: a casa que chama. Ele é desenhado em `currentColor` de propósito --
 * assim herda o alto contraste junto com o texto ao redor, sem precisar de uma
 * versão paralela para o modo acessível.
 *
 * O logotipo ("Chama Um") é TEXTO, não caminho vetorial. Um wordmark vetorizado
 * ignora a preferência de fonte grande da pessoa e some do leitor de tela;
 * texto real cresce com o resto da interface.
 */
export function Logo({
  variante = 'completa',
  tamanho = 32,
  titulo,
  className,
}: {
  variante?: 'completa' | 'simbolo';
  tamanho?: number;
  /**
   * Quando informado, o símbolo vira uma imagem anunciada com este nome. Sem
   * ele, o símbolo é decorativo -- é o caso dentro de um link que já tem o
   * texto "Chama Um" do lado, onde anunciar as duas coisas faria o leitor de
   * tela repetir a marca duas vezes seguidas.
   */
  titulo?: string;
  className?: string;
}) {
  const simbolo = (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 64 64"
      role={titulo ? 'img' : undefined}
      aria-label={titulo}
      aria-hidden={titulo ? undefined : true}
      focusable="false"
      className="shrink-0"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M32 3.2 L62.4 26.4 A1.6 1.6 0 0 1 61.4 29.3 L56.8 29.3 L56.8 57.6 A2.4 2.4 0 0 1 54.4 60 L9.6 60 A2.4 2.4 0 0 1 7.2 57.6 L7.2 29.3 L2.6 29.3 A1.6 1.6 0 0 1 1.6 26.4 Z M20.6 27.2 A6.4 6.4 0 0 0 14.2 33.6 L14.2 41.6 A6.4 6.4 0 0 0 20.6 48 L21.4 48 L15.8 56.4 L32.4 48 L43.4 48 A6.4 6.4 0 0 0 49.8 41.6 L49.8 33.6 A6.4 6.4 0 0 0 43.4 27.2 Z"
      />
    </svg>
  );

  if (variante === 'simbolo') {
    return <span className={className}>{simbolo}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2 whitespace-nowrap ${className ?? ''}`}>
      {simbolo}
      <span
        className="logo-texto font-[family-name:var(--font-titulo)] font-extrabold tracking-[-0.03em]"
        style={{ fontSize: tamanho * 0.72, fontStretch: '92%' }}
      >
        Chama Um
      </span>
    </span>
  );
}
